import { ProjectService } from '../project.service';
import { CompareProjectsService } from './../compare-projects.service';
import { Component, OnInit } from '@angular/core';
import { Project } from '../project';
import { ModalService } from '../modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-my-projects',
  templateUrl: './my-projects.component.html',
  styleUrls: ['./my-projects.component.sass']
})
export class MyProjectsComponent implements OnInit {
  title: string = "PORÓWNAJ SWOJE PROJEKTY I WYBIERZ NAJLEPSZY";
  subtitle: string = '';
  next: string = "/finished-project"
  prev: string = "edit"
  projects: Project[];
  selectedProject: Project = null;
  from: string = null;
  projectToDelete: Project = null;
  constructor(
    private compareProjectsService: CompareProjectsService,
    private modalService: ModalService,
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
    ) { }

  ngOnInit() {
    this.projects = this.compareProjectsService.getProjects();
    this.from = this.route.snapshot.paramMap.get('from');
    console.log(this.route);
    console.log(this.location);
  }

  deleteProject() {
    this.compareProjectsService.deleteProject(this.projectToDelete);
    this.modalService.close('delete-dlg');
    if (this.from == 'fromedit') {
      this.modalService.open('edit-dlg');
    }
  }

  onDeleteProject(project: Project) {
    this.projectToDelete = project;
    this.modalService.open('delete-dlg');
  }

  selectProject(project: Project) {
    if (this.selectedProject == project) {
      this.selectedProject = null;
    } else {
      this.selectedProject = project;
    }
    this.projectService.setProject(this.selectedProject);
  }

  previewProject(project: Project) {
    var image: HTMLImageElement = <HTMLImageElement>document.getElementsByClassName('preview-image')[0];
    image.src = project.projectImageFile;
    this.modalService.open('preview-dialog');
  }

  editProject(project: Project) {
    this.projectService.setProject(project);
    this.router.navigate(['/editor']);
  }

  notice() {
    this.modalService.open('notice-dlg');
  }

  closeModal() {
    this.modalService.close('preview-dialog');
    this.modalService.close('edit-dlg');
    this.modalService.close('notice-dlg');
    this.modalService.close('delete-dlg');
  }

  accept() {
    this.modalService.close('edit-dlg');
    this.location.back();
  }

  decline() {
    this.modalService.close('edit-dlg');
  }

  onNextClick(event: string) {
    if (this.selectedProject) {
      this.router.navigate([this.next])
    } else {
      this.notice();
    }
  }
}
